import './codeunlock.css';
import { Link,useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
//import contentData from './ContentData';
import { useAuth } from 'react-oidc-context';
import AppContext from '../../AppContext';
import UserContext from '../../UserContext';
import { useContext,useEffect } from 'react';

function CodeUnlock({contentpage}) {
    const appcontext = useContext(AppContext);
    const usercontext = useContext(UserContext);
    //const content = contentData[contentpage] || contentData.default;
    const content={
        backgroundImage:'url(/pages/codeunlock-bg1.png)',
        mainTitle:'Attiva gratuitamente i tuoi prodotti digitali Giappichelli',
        subTitle:'Per procedere all\'attivazione accedi al tuo account',
        subTitlebis:'o registrati',
    };
    const auth = useAuth();
    const isAuthenticated = auth.isAuthenticated;
    let navigate = useNavigate();

    useEffect(() => {
	const checkPrimoAccesso=async function(){
		const user=usercontext.user;
		if(user.professione);else return navigate('/profilo/primoaccesso/?redirect='+encodeURIComponent(document.location.href));
	};
	if(usercontext && usercontext.user)
		checkPrimoAccesso();
    }, [appcontext,auth,usercontext,navigate]);


	const doLogin=function(){
		navigate('/login/?redirect='+encodeURIComponent(document.location.href));
	};
	const doRegister=function(){
		navigate('/register/?redirect='+encodeURIComponent(document.location.href));
	};

    return (
        <div className='page'>
            <div className='row h-100 g-0'>
                <div className='col-6 page-background' style={{ backgroundImage: content.backgroundImage }}></div>
                <div className='col-sm-5 col-md-6 col-lg-5 col-xl-6 page-right codeunlock'>
                    <div className='headings'>
                        <h1>{content.mainTitle}</h1>
                        <h2>{content.subTitle}{content.subTitlebis?(<><br />{content.subTitlebis}</>):(<></>)}</h2>
                    </div>
                    <hr style={{maxWidth:'100%'}} />
                    <div className='contents bottom-info'>
			{content.subTitle2?(<>
                            <h4>{content.subTitle2}</h4>
                            <h4>{content.subTitle3}</h4>
			</>):(<>
			{content.listTitle?(<>
                        <div className='list'>
                            <h4>{content.listTitle}</h4>
                            <div className='list-items'>
                                {content.listItems.map((item, index) => (
                                    <div key={index} className='list-item'>
                                        <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} alt='list-icon'/>
                                        <div>
                                            {item.parts.map((part, i) => (
                                                <span key={i} className={part.type === 'bold' ? 'bold' : ''}>
                                                    {part.text}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div></>):(<></>)}</>)}
                        <hr style={{maxWidth:'100%'}} />
                        <div className="row w-100 buttons-container">
                            {isAuthenticated ? (
                                <div className="col">
                                    <a className='gradient-button' href="?show=activateProduct">Attiva prodotto</a>
                                </div>
                            ) : (
                                <>
                                    <div className="col-md-6">
                                        <button type="button" className='gradient-button reset-button' onClick={doLogin} style={{width:'100%',marginBottom:'16px'}}>Accedi</button>
                                    </div>
                                    <div className="col-md-6">
                                        <button type="button" className='gradient-button' onClick={doRegister} style={{width:'100%'}}>Registrati</button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CodeUnlock;
 
